import styled from 'styled-components';

export const RadioGroupContainer = styled.fieldset`
  border: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
`;
